import {
  ACTION_COMMON_SET_MEDIA_REQUEST,
  ACTION_MORE_VIDEOS_SET_INTERACTION_ON_END_STATE,
  ACTION_MORE_VIDEOS_SHOW_GALLERY_VIEW,
  ACTION_USER_INTERACTION,
} from '../../../common/store/store.actions';
import { UserInteractionTypes } from '../../../common/store/store.types';
import {
  ACTION_MONETIZATION_ADD_CUST_PARAM,
  ACTION_MONETIZATION_REMOVE_CUST_PARAM
} from '../../../core/store/actions/monetization.actions';

export const playAnotherVideoFromList = (videoIndex: number) => (dispatch): void => {
  dispatch({
    type: ACTION_COMMON_SET_MEDIA_REQUEST,
    payload: { mediaRequestObject: { type: 'playAnotherVideoFromList', value: videoIndex } },
  });
};

export const playVideoFromRecommendations = (videoIndex: number) => (dispatch): void => {
  dispatch({
    type: ACTION_COMMON_SET_MEDIA_REQUEST,
    payload: { mediaRequestObject: { type: 'playVideoFromRecommendations', value: videoIndex } },
  });
};

export const setShowGalleryView = (showGallery: boolean) => (dispatch): void => {
  dispatch({
    type: ACTION_MORE_VIDEOS_SHOW_GALLERY_VIEW,
    payload: showGallery,
  });
};

export const setUserInteraction = (interaction: UserInteractionTypes) => (dispatch): void => {
  dispatch({
    type: ACTION_USER_INTERACTION,
    payload: interaction,
  });
};

export const setInteractionOnEndState = (interactionOnEndState: boolean) => (dispatch): void => {
  dispatch({
    type: ACTION_MORE_VIDEOS_SET_INTERACTION_ON_END_STATE,
    payload: interactionOnEndState,
  });
};

export const setAdCustomParams = (key: string, value: string) => (dispatch): void => {
  const payload = { key, value };
  dispatch({
    type: ACTION_MONETIZATION_ADD_CUST_PARAM,
    payload,
  });
};

export const removeAdCustomParams = (key: string) => (dispatch): void => {
  const payload = { key };
  dispatch({ type: ACTION_MONETIZATION_REMOVE_CUST_PARAM, payload });
};
